<script lang="ts">
  import type { BeforeState } from '@pin/schemas/client-state-response';
  import AlternativeList from '../components/AlternativeList.svelte';
  import { onMount } from 'svelte';
  import { trackEvent } from '../util/snowplow';
  import { i18n } from '../util/i18n/i18n';
  import SKAlternativeItem from '../components/Stjernekamp/SKAlternativeItem.svelte';

  export let pollData: BeforeState;

  onMount(() => {
    trackEvent(
      { action: 'state:before-poll', label: pollData.title },
      pollData.id
    );
  });
</script>

<!-- svelte-ignore a11y-autofocus -->
<h2 autofocus tabindex="-1">{i18n('poll.before')}</h2>
<AlternativeList>
  {#each pollData.alternatives as alternative, i}
    <SKAlternativeItem
      imagePos={i % 2 === 0 ? 'left' : 'right'}
      {alternative}
    />
  {/each}
</AlternativeList>
